import React, { useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import classNames from 'classnames/bind';
import LayerComm from 'app/components/common/LayerComm';
import styles from './MaintenanceNotice.module.scss';

const cx = classNames.bind(styles);

// 정산 마감 점검 안내 (503 점검 시간대 공통 레이어)
function MaintenanceNotice({ show, maintenanceTime = '' }) {
	useEffect(() => {
		if (show) {
			disableBodyScroll(document.body);
		} else {
			enableBodyScroll(document.body);
		}
		return () => clearAllBodyScrollLocks();
	}, [show]);

	if (!show) return null;

	return (
		<LayerComm
			layerClass="uilayer_maintenance"
			dimmedClick={false}
			onClose={() => null}
			layerSize="320px"
		>
			<div className={cx('popup')}>
				<div className={cx('title')}>
					<p className={cx('tit')}>정산 마감 점검 안내</p>
				</div>
				<div className={cx('content')}>
					<p className={cx('desc')}>
						원활한 정산 마감 처리를 위해
						<br />
						시스템 점검이 진행됩니다.
					</p>
					<div className={cx('notice_box')}>
						<p className={cx('notice_warn')}>
							점검 시간 동안 일부 서비스(정산) 이용이
							<br />
							일시적으로 제한될 수 있습니다.
							{maintenanceTime && (
								<>
									<br />
									{`(점검 시간 : ${maintenanceTime})`}
								</>
							)}
						</p>
					</div>
					<p className={cx('foot')}>점검 완료 후 정상적으로 이용 가능합니다.</p>
				</div>
			</div>
		</LayerComm>
	);
}

export default MaintenanceNotice;
